import header from "./closeup-unrecognizable-couple-signing-contract.jpg";
import section1 from "./midsection-real-estate-agent-client-table.jpg";
import section2 from "./happy-mid-adult-businessman-talking-with-candidate.jpg";
import section3 from "./happy-blonde-female-manager-has-conversation.jpg";
import section4 from "./midsection-man-working-table.jpg";
import section5 from "./mortgage-apartment-purchase-keys.jpg";
import section6 from "./delighted-young-couple-singing-papers.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
